import { useMenu } from "../contexts/MenuContext";
import apiFetch from "@wordpress/api-fetch";

export const useFormSave = (sectionPath = null) => {
	const { settingData, setSettingData } = useMenu();

	// Helper: Get nested value
	const getNestedValue = (obj, path) => {
		if (!path || !obj) return obj;
		return path.split(".").reduce((acc, part) => acc?.[part], obj);
	};

	const handleSave = async () => {
		const OPTIONS_API_URL = "ultimate-security/v1/options";
		const dataToSave = { ultimate_security_options: {} };

		if (sectionPath) {
			const sectionData = getNestedValue(settingData, sectionPath);
			const pathParts = sectionPath.split(".");
			let current = dataToSave["ultimate_security_options"];
			for (let i = 0; i < pathParts.length - 1; i++) {
				if (!current[pathParts[i]]) current[pathParts[i]] = {};
				current = current[pathParts[i]];
			}
			current[pathParts[pathParts.length - 1]] = sectionData;
		} else {
			dataToSave["ultimate_security_options"] = settingData;
		}

		try {
			await apiFetch({
				path: OPTIONS_API_URL,
				method: "POST",
				data: dataToSave,
			});

			// Clean up localStorage
			if (sectionPath) {
				localStorage.removeItem(`changes_${sectionPath}`);
			} else {
				localStorage.removeItem("changes_all");
			}

			return true;
		} catch (error) {
			console.error("Error saving settings:", error);
			return false;
		}
	};

	return { handleSave };
};
